(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_tab-product-list"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tab-product-list')) {
    customElements.define('tab-product-list', class extends HTMLElement {
      constructor() {
        super();
        this.syncTabs = this.syncTabs.bind(this);
        this.onSectionLoad = (event) => {
          if (event.target.contains(this)) this.syncTabs();
        };
      }

      connectedCallback() {
        this.menu = this.closest('[data-tab-menu]');
        this.frame = requestAnimationFrame(this.syncTabs);
        document.addEventListener('DOMContentLoaded', this.syncTabs);
        window.addEventListener('load', this.syncTabs);
        document.addEventListener('shopify:section:load', this.onSectionLoad);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        document.removeEventListener('DOMContentLoaded', this.syncTabs);
        window.removeEventListener('load', this.syncTabs);
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
        // The shared tab head lives outside this element. Return its buttons so
        // a removed/reordered instance cannot leave orphan buttons in that head.
        this.menu?.querySelectorAll('[data-tab-owner]').forEach((button) => {
          if (button.dataset.tabOwner === this.id && !this.contains(button)) {
            this.append(button);
          }
        });
      }

      syncTabs() {
        if (!this.isConnected || !this.menu || typeof syncTabButtonHeads !== 'function') return;
        // A section refresh may retain the active ID but replace its DOM nodes.
        // Force the existing tab controller to apply state to the new nodes.
        delete this.menu.dataset.tabReady;
        delete this.menu.dataset.activeTabId;
        syncTabButtonHeads(this.menu);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
